import moment from 'moment'

export function getRelievingDate(user) {
  const offDutyHistory = user?.history?.filter(
    (h) => h?.status === 'Off Duty' && h?.updatedDate
  )
  if (offDutyHistory?.length > 0) {
    return moment(offDutyHistory[0]?.updatedDate).format('lll')
  }
  return moment(user?.tentativeRelievingDate).format('lll')
}
export function getReportingDate(user) {
  const startDutyHistory = user?.history?.filter(
    (h) => h?.status === 'Start Duty' && h?.updatedDate
  )
  if (startDutyHistory?.length > 0) {
    return moment(startDutyHistory[0]?.updatedDate)
  }
  return moment(user?.reportingDate)
}
